var React = require('react');

function FlowTriangleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30 40L6.26352e-08 79.8372L3.54531e-06 0.162829L30 40Z"}));
}

FlowTriangleInline.defaultProps = {"width":"30","height":"80","viewBox":"0 0 30 80","fill":"none"};

module.exports = FlowTriangleInline;

FlowTriangleInline.default = FlowTriangleInline;
